<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0">

    <form [formGroup]="formGroup" class="canton-form">
      <mat-form-field class="width-100">
        <mat-label>{{ 'Credit' | translate }}</mat-label>
        <input formControlName="credit" matInput required type="number" min="0">
        @if (formGroup.get('credit')?.hasError('max')) {
          <mat-error>
            Kann die max Anzahl Credits nicht überschreiten
          </mat-error>
        }
        @if (formGroup.get('credit')?.hasError('min')) {
          <mat-error>
            Cant`t be less than 1
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill" class="width-100">
        <mat-label>{{'Event-Typ' | translate}}</mat-label>
        <mat-select formControlName="eventTypeId" required>
          @for (et of eventTypes; track et) {
            <mat-option [value]="et.value">
              {{et?.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

    @if (action !=='edit') {
      <button
        mat-raised-button
        (click)="dialogRef.close([formGroup, chosenEventType])"
        class="save-button mat-accent"
        [disabled]="formGroup && formGroup.invalid"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-raised-button
        (click)="dialogRef.close(['save',formGroup])"
        class="save-button mat-accent"
        [disabled]="formGroup && formGroup.invalid"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-button
        class="mat-icon-button"
        (click)="dialogRef.close(['delete',formGroup])"
        aria-label="Delete"
        matTooltip="Delete">
        <mat-icon>delete</mat-icon>
      </button>
    }

  </div>
</div>
